import { createContext } from 'react';
import RootStore from '@/stores/RootStore';

type RootStoreInstance = InstanceType<typeof RootStore>;

const StoreContext = createContext<RootStoreInstance>({} as RootStore);

export { RootStoreInstance, StoreContext };
